import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ApiKeysPage } from "src/components/views/ai/customFunctions/apiKeys/ApiKeysPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/customizations/api-keys")({
	staticData: { title: i18n.t("api_keys"), legacyViewKey: "apiKeysPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ApiKeysPage />;
}
